import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  // TextInput,
  NumberField,
  NumberInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const ServiceConfigList = ({ isEdit }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <TextField source="title" />
      <NumberField source="latestBuildVersion" />
      <NumberField source="minSupportedBuildVersion" />
    </Datagrid>
  </List>
)

export const ServiceConfigEdit = () => (
  <Edit>
    <SimpleForm>
      <NumberInput source="latestBuildVersion" />
      <NumberInput source="minSupportedBuildVersion" />
    </SimpleForm>
  </Edit>
)

export const ServiceConfigShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <NumberField source="latestBuildVersion" />
      <NumberField source="minSupportedBuildVersion" />
    </SimpleShowLayout>
  </Show>
)
